/* eslint-disable */

import VuePhoneInput from './VuePhoneInput';

/* eslint-enable */

import './style.scss';

export default VuePhoneInput;

/* eslint-disable no-undef */

if (window && window.Vue) {
  window.Vue.component('vue-phone-input', VuePhoneInput);
}

/* eslint-enable no-undef */



// WEBPACK FOOTER //
// ./src/components/Shared/TelInput/vue-phone-input/index.js